export const stringAvatar = (name: string) => {
  const [lastName, firstName] = name.split(' ');

  return {
    children: `${firstName?.charAt(0) ?? ''}${lastName?.charAt(0) ?? ''}`,
  };
};
